export const logoUrl = 'https://secure-smartcfo.s3.us-east-2.amazonaws.com/images/public/logo/logo-full.png';
export const iconUrl = 'https://secure-smartcfo.s3.us-east-2.amazonaws.com/images/public/logo/logo_no_background_donut.png';
export const palette = ['#94CECC', '#EB5560', '#488E9D', '#E65A54'];